import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-dark',
  templateUrl: './header-dark.component.html',
  styleUrls: ['./header-dark.component.scss']
})
export class HeaderDarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
